import React, { useState } from "react";
import Dashboard from "./components/Dashboard";
import Inventory from "./components/Inventory";
import Billing from "./components/Billing";
import Schemes from "./components/Schemes";
import Orders from "./components/Orders";
import WhatsApp from "./components/WhatsApp";
import Login from "./components/Login";
import Register from "./components/Register";

function App() {
  const [page, setPage] = useState("dashboard");
  const [authPage, setAuthPage] = useState("login");
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem("userId", userData.userId);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    setUser(null);
    setAuthPage("login");
  };

  if (!user) {
    return authPage === "login" ? (
      <Login
        onLogin={handleLogin}
        goToRegister={() => setAuthPage("register")}
      />
    ) : (
      <Register goToLogin={() => setAuthPage("login")} />
    );
  }

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f8f9fa",
        fontFamily: "Arial",
      }}
    >
      {/* Sidebar */}
      <div
        style={{
          width: "220px",
          background: "#856A00",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
        }}
      >
        <img
          src="https://botmotautomations.com/wp-content/uploads/2025/06/cropped-cropped-Logo-1-1-50x38.png"
          alt="BotMot Logo"
          style={{ width: "50px", marginBottom: "8px" }}
        />
        <div style={{ fontSize: "16px", fontWeight: "bold", color: "gold" }}>
          Swarna
        </div>
        <div
          style={{ fontSize: "11px", color: "#f0d080", marginBottom: "8px" }}
        >
          by BotMot Automations
        </div>
        <div
          style={{
            fontSize: "12px",
            color: "#f0d080",
            marginBottom: "24px",
            padding: "6px 8px",
            background: "#403301",
            borderRadius: "6px",
          }}
        >
          👤 {user.name} · {user.shopName}
        </div>

        {[
          "Dashboard",
          "Inventory",
          "Billing",
          "Schemes",
          "Orders",
          "WhatsApp",
        ].map((item, i) => (
          <div
            key={i}
            onClick={() => setPage(item.toLowerCase())}
            style={{
              padding: "10px 12px",
              marginBottom: "4px",
              borderRadius: "6px",
              cursor: "pointer",
              background:
                page === item.toLowerCase() ? "#b8ab39" : "transparent",
              color: page === item.toLowerCase() ? "#403301" : "#efbf04",
              fontSize: "13px",
              fontWeight: page === item.toLowerCase() ? "bold" : "normal",
              borderLeft:
                page === item.toLowerCase()
                  ? "3px solid #403301"
                  : "3px solid transparent",
            }}
          >
            {item}
          </div>
        ))}

        {/* Logout */}
        <div style={{ marginTop: "auto" }}>
          <button
            onClick={handleLogout}
            style={{
              width: "100%",
              background: "#403301",
              color: "#efbf04",
              border: "1px solid #856A00",
              padding: "8px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "12px",
            }}
          >
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1 }}>
        {page === "dashboard" && <Dashboard />}
        {page === "inventory" && <Inventory />}
        {page === "billing" && <Billing />}
        {page === "schemes" && <Schemes />}
        {page === "orders" && <Orders />}
        {page === "whatsapp" && <WhatsApp />}
      </div>
    </div>
  );
}

export default App;
